module.exports = __webpack_public_path__ + "media/images/athletes/2189-2f1198055c94129bee7cb1d71ee9515d.png";